<script>
    export let buttonText = "",
        classNames = "",
        flex = "";
</script>

<!--src/components/Button.svelte-->
<button on:click class="button rounded-edge {classNames}" style="flex:{flex}" type="type">
    <slot name="leading" />
    <span>{buttonText}</span>
    <slot name="trailing" />
</button>

<style>
    button {
        height: 40px;
        background-color: var(--primaryColor);
        display: flex;
        flex: 0 1 33%;
        justify-content: center;
        align-items: center;
        padding: 8px 24px;
        font-weight: 400;
        cursor: pointer;
    }
    button.short {
        height: 32px;
    }
    button slot {
        display: flex;
    }
    button div {
        flex: 1;
        color: var(--backgroundColorLightest);
    }
    button.secondary {
        background-color: transparent;
        border: 1px solid var(--backgroundColorMedium);
    }
    button.secondary.dark {
        background-color: transparent;
        border: 1px solid var(--backgroundColorDark);
        color: #000;
    }
    button.secondary div {
        color: var(--textColorDarkest);
    }
    button.outline.tertiary {
        background-color: inherit;
        color: var(--textColorDarkest);
        border: 1px solid #c6c6c6;
        box-sizing: border-box;
        border-radius: 6px;
    }
    button.outline.tertiary div {
        color: var(--textColorDarkest);
    }
    button.solid.tertiary {
        background: rgba(102, 102, 102, 0.6);
        border-radius: 6px;
    }
    button.solid.tertiary {
        color: var(--backgroundColorLightest);
    }
    button.transparent {
        background-color: transparent;
    }
    .far-right-auto {
        margin-left: auto;
        margin-right: 0px;
    }

    .short {
        margin-top: 8px;
        height: 32px;
    }

    .w176px {
        width: 176px;
        margin-right: 16px;
        flex: none;
    }

    button.feedback-submit {
        font-weight: 700;
        height: 40px;
        width: 240px;
    }
    button.feedback-submit.inactive {
        background: rgba(102, 102, 102, 0.6);
        cursor: default;
    }

    button.payment-option {
        height: 32px;
        border: 1px solid #c6c6c6;
        background-color: #ffffff;
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        padding: 0px;
        justify-content: flex-start;
        margin: 0px 8px 0px 0px;
        user-select: none;
        flex: 1;
    }
    button.payment-option div {
        color: var(--textColorDarkest);
    }
    button.payment-option.selected {
        font-weight: 700;
        border: 2px solid #c6c6c6;
    }

    button.light-bg {
        color: #000000;
    }
</style>
